export class MockConsole {
  public static logSpy: jest.SpyInstance;
  public static warnSpy: jest.SpyInstance;
  public static errorSpy: jest.SpyInstance;

  public static setup(): void {
    this.logSpy = jest.spyOn(console, "log").mockImplementation();
    this.warnSpy = jest.spyOn(console, "warn").mockImplementation();
    this.errorSpy = jest.spyOn(console, "error").mockImplementation();
  }

  public static teardown(): void {
    this.logSpy.mockRestore();
    this.warnSpy.mockRestore();
    this.errorSpy.mockRestore();
  }
}
